import { useState } from 'react';
import { UserPlus } from 'lucide-react';

export const BulkAssign = ({ ids, people, api, onDone }) => {
  const [who, setWho] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const run = async (payload, label) => {
    if (!window.confirm(`Assign ${ids.length} student(s) to ${label}? Each change is logged in the student's history.`)) return;
    setBusy(true); setMsg('');
    const d = await api('/students/bulk-assign', { method: 'POST', body: JSON.stringify({ member_ids: ids, ...payload }) }, true);
    setBusy(false);
    if (d.error) { setMsg(d.error); return; }
    onDone(`Assigned ${d.updated} student(s) to ${d.assigned_to || 'nobody (unassigned)'}${d.unchanged ? ` (${d.unchanged} already assigned)` : ''}.`);
  };
  return (
    <div className="flex items-center gap-2" data-testid="bulk-assign">
      <button type="button" disabled={busy} onClick={() => run({ to_me: true }, 'yourself')} className="rounded-full bg-teal-400 text-[#0b1f4d] text-sm font-semibold px-4 py-2 disabled:opacity-50" data-testid="bulk-assign-me-btn">
        Assign to me
      </button>
      <select value={who} onChange={(e) => setWho(e.target.value)} className="h-9 rounded-full bg-white/10 border border-white/20 text-sm px-3 text-white" data-testid="bulk-assign-select">
        <option value="" className="text-slate-900">Unassigned</option>
        {people.map((p) => <option key={p} value={p} className="text-slate-900">{p}</option>)}
      </select>
      <button type="button" disabled={busy} onClick={() => run({ assigned_to: who }, who || 'nobody (unassign)')} className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#0b1f4d] text-sm font-semibold px-4 py-2 disabled:opacity-50" data-testid="bulk-assign-apply-btn">
        <UserPlus className="w-4 h-4" />Assign
      </button>
      {msg && <span className="text-xs text-red-200" data-testid="bulk-assign-error">{msg}</span>}
    </div>
  );
};
